import Button from '@/components/@base/button';
import Props from '@/components/app/product/components/questions/add-question/add-question-btn/type';

import { pageLevelLocalization } from '@/constant/localization';

import AddIcon from '~/images/icons/add';

const { product: productLocalization } = pageLevelLocalization;

export default function AddQuestionButton({ onAddQuestionClick, ...props }: Props) {
  return (
    <Button
      Icon={
        <AddIcon
          width={15}
          height={15}
          fill='fill-[#81CF33] group-hover:fill-[#FFFFFF]'
          className='h-3 w-3 fill-current text-[#81CF33] transition-all duration-300 group-hover:fill-[#FFFFFF] md:h-[15px] md:w-[15px]'
        />
      }
      onClick={onAddQuestionClick}
      className='group h-12 bg-[#F5FBED] px-[13px] py-2.5 text-[13px] font-bold text-[#81CF33] transition-all hover:bg-[#81CF33] hover:text-[#FFFFFF]'
      {...props}
    >
      {productLocalization.addQuestion}
    </Button>
  );
}
